module.exports = {
  install(Vue, options) {
    const dayjs = options && options.dayjs ? options.dayjs : require('@/utils/dayjs').default;

    Vue.prototype.$dayjs = dayjs;

    Vue.filter('dayjs', (...args) => {
      const [ value, format = 'YYYY-MM-DD' ] = args;

      if (
        value === undefined ||
        value === null ||
        value === ''
      ) return value;

      return dayjs.utc(value).local().format(format);
    });

  },
};
